/**
 * jj-source-attribution
 *
 * Records which in-store section a shopper came from when they add to cart,
 * so we can tell whether a section actually sells.
 *
 * Sections that link to a PDP append `jj_src=<surface>:<origin>` to their
 * links. On the destination PDP this script reads the param and injects two
 * hidden line item properties into the add to cart form:
 *
 *     properties[_source]      = surface, e.g. pair-with, edit-carousel
 *     properties[_source_from] = where exactly, e.g. vega-dress, an article
 *
 * The underscore keeps both out of the cart, checkout, emails and the admin
 * order screen. They still ride onto the order and are readable through the
 * Admin API as lineItems { customAttributes }.
 *
 * Sections that add to cart in place (the carousel's size buttons) do not
 * need this script. They post their own properties straight to /cart/add.js.
 *
 * Attribution is STRICT: the stamp lives for one page load only. Navigate
 * away and it is gone, so nothing later in the session is credited to the
 * section. The param is removed from the address bar once read, so a shopper
 * who copies the URL does not pass the attribution on.
 *
 * Adding a surface needs no change here, only a `jj_src` on the section's
 * links. Keep the surface name short and stable so old orders stay countable.
 */
(function () {
  'use strict';

  var PARAM = 'jj_src';
  var LEGACY_PARAM = 'pw_from';
  var SURFACE = /^[a-z0-9][a-z0-9-]{0,63}$/;
  var ORIGIN = /^[a-z0-9][a-z0-9-]{0,127}$/;

  var surface = null;
  var origin = null;
  var url;

  try {
    url = new URL(window.location.href);
  } catch (e) {
    return;
  }

  var raw = url.searchParams.get(PARAM);
  if (raw) {
    // Anyone can craft this URL, so accept only the shape we write ourselves.
    var parts = raw.split(':');
    if (SURFACE.test(parts[0])) {
      surface = parts[0];
      if (parts.length > 1 && ORIGIN.test(parts[1])) origin = parts[1];
    }
  } else {
    // The pair-with widget shipped with its own param before this script was
    // generalised. Safe to delete once no live page carries it.
    var legacy = url.searchParams.get(LEGACY_PARAM);
    if (legacy && ORIGIN.test(legacy)) {
      surface = 'pair-with';
      origin = legacy;
    }
  }

  if (!surface) return;

  // Read once, then clean the address bar. The values live in this closure for
  // the rest of the page load, including across variant changes.
  try {
    url.searchParams.delete(PARAM);
    url.searchParams.delete(LEGACY_PARAM);
    window.history.replaceState(window.history.state, '', url.toString());
  } catch (e) {
    /* a dirty URL is not worth failing over */
  }

  function put(form, name, value) {
    if (!value || form.querySelector('input[name="' + name + '"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function stamp(form) {
    if (!form) return;
    put(form, 'properties[_source]', surface);
    put(form, 'properties[_source_from]', origin);
  }

  function stampAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(stamp);
  }

  stampAll();

  // The variant picker re-renders the form from the server on every colour or
  // size change, which drops anything we injected. Capture phase runs before
  // the theme's own submit handler builds its FormData, so this is the
  // backstop that matters.
  document.addEventListener('submit', function (event) {
    stamp(event.target.closest && event.target.closest('form[action*="/cart/add"]'));
  }, true);

  // Belt and braces for the dynamic checkout button, which does not go through
  // a submit event we can see.
  document.addEventListener('product:rerender', stampAll);
  document.addEventListener('variant:change', stampAll);
})();
